import type { i18n as I18n } from 'i18next';

// 'en' alone resolves to US order (month first) but the product shows English dates day first;
// 'df' (formal German) is not a real locale tag and would fall back to the browser's language.
const INTL_LOCALE_BY_APP_LANGUAGE: Record<string, string> = {
  en: 'en-GB',
  df: 'de-DE',
};

export const intlLocale = (language: string): string =>
  INTL_LOCALE_BY_APP_LANGUAGE[language] ?? language;

export const registerListFormatter = (i18n: I18n): void => {
  // i18next hands Intl the app language code, and codes like 'df' aren't Intl locale tags.
  i18n.services.formatter?.addCached('list', (lng, options) => {
    const formatter = new Intl.ListFormat(lng === undefined ? undefined : intlLocale(lng), options);
    return (value) => formatter.format(value);
  });
};
